import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  padding: 10px 0 31px 0;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  ${''}
`;

export const ReadOnlyValue = styled.div`
  width: '162px';
  height: '22px';
`;

export const RowTitle = styled.div`
  width: 190px;
  height: 24px;
  font-family: Heebo-Medium;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.4;
  letter-spacing: normal;
  text-align: left;
  padding-right: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RowInputWrapper = styled.div``;
